import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { abTestFeature } from './ab-test.reducer';

@NgModule({
  imports: [StoreModule.forFeature(abTestFeature)],
})
export class AbTestStateModule {}
